import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Button,
    MenuItem,
    InputLabel,
    FormControl,
    Grid,
  } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import { TextField, Select } from "formik-material-ui";
import { universities, fields } from '../edu';
import {countries,years} from '../listOfCountries'

import * as Yup from "yup";

const degreeLevels = [
    "Bachelor's Degree",
    "Master's Degree" ,
    "Doctorate Degree" ,
    "Associate's Degree" ,
    "Diploma" ,
    "Certificate" 
]



const infoSchema = Yup.object().shape({
    degree: Yup.string().required('Required'),
    country: Yup.string().required('Required'),
    university: Yup.string().required('Required'),
    field: Yup.string().required('Required'),
    grade: Yup.string().required('Required'),
    start: Yup.string().required('Required'),
    end: Yup.string().required('Required'),
    description: Yup.string().max(800, "Too Long")
});

const EducationModal = (props) => {
    const { user } = useAuth0()

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        // console.log(values)
        if(props.degree.id === ''){
            fetch(process.env.REACT_APP_IP + `/talent/adddegree/${user.sub}`, {
                method: 'POST',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values)
            }).then(res => res.json())
            .then(res => console.log(res));
        } else {
            fetch(process.env.REACT_APP_IP + `/talent/updatedegree/${user.sub}/${props.degree.id}`, {
                method: 'PATCH',
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values)
            }).then(res => res.json())
            .then(res => console.log(res));
        }
        props.refresh();
        props.onClose();
    }

    return (
            <Dialog open={props.open} onClose={props.onClose} aria-labelledby="form-dialog-title" fullWidth maxWidth={'sm'}>
                <DialogTitle id="form-dialog-title">{ (props.degree.id === '')? "Add" : "Edit"} Degree</DialogTitle>
                <Formik
                initialValues={{
                    degree: props.degree.degree,
                    country: props.degree.country,
                    university: props.degree.university,
                    field: props.degree.field,
                    grade: props.degree.grade,
                    start: props.degree.start,
                    end: props.degree.end,
                    description: props.degree.description
                }}
                validationSchema={infoSchema}
                onSubmit={(values, { setSubmitting }) => {
                handleSubmit(values, { setSubmitting });
                }}
                >
                {({ submitForm, isSubmitting }) => (
                    <Form>
                        <DialogContent>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="degree">Degree Level</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="degree"
                                inputProps={{
                                    id: "degree",
                                }}>
                                    { degreeLevels.map((degree, index) => 
                                        <MenuItem key={index} value={degree}>{degree}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="country">Country</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="country"
                                inputProps={{
                                    id: "country",
                                }}>
                                    { countries.map((country, index) => 
                                        <MenuItem key={index} value={country}>{country}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="university">University</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="university"
                                inputProps={{
                                    id: "university",
                                }}>
                                    { universities.map((uni, index) => 
                                        <MenuItem key={index} value={uni.name}>{uni.name}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="field">Field of Study</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="field"
                                inputProps={{
                                    id: "field",
                                }}>
                                    { fields.map((field, index) => 
                                        <MenuItem key={index} value={field}>{field}</MenuItem>)
                                    }
                                </Field>
                            </FormControl>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="grade">Grade</InputLabel>
                                <Field
                                required
                                component={Select}
                                name="grade"
                                inputProps={{
                                    id: "grade",
                                }}>
                                    <MenuItem value="excellent">excellent</MenuItem>
                                    <MenuItem value="very good">very good</MenuItem>
                                    <MenuItem value="good">good</MenuItem>
                                    <MenuItem value="completed">completed</MenuItem>
                                </Field>
                            </FormControl>
                            <Grid container direction='row' justify='space-between' alignItems='center'>
                                <Grid item xs={5}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="start">Start year</InputLabel>
                                        <Field
                                        required
                                        component={Select}
                                        name="start"
                                        inputProps={{
                                            id: "start",
                                        }}>
                                            { years.map((year, index) => 
                                                <MenuItem key={index} value={year}>{year}</MenuItem>
                                            )}
                                        </Field>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={5}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="end">end year</InputLabel>
                                        <Field
                                        required
                                        component={Select}
                                        name="end"
                                        inputProps={{
                                            id: "end",
                                        }}>
                                            { years.map((year, index) => 
                                                <MenuItem key={index} value={year}>{year}</MenuItem>
                                            )}
                                        </Field>
                                    </FormControl>
                                </Grid>
                                <small style={{marginTop: 10}}>If you're still studying, add your exsmallcted graduation year</small>
                            </Grid>
                            <Field fullWidth
                            name="description"
                            component={TextField}
                            id="description"
                            label="Description"
                            multiline
                            rows={3}
                            helperText="max 800 characters"
                            placeHolder=""
                            />
                        </DialogContent>
                        <DialogActions>
                        <Button disabled={isSubmitting} color="primary" onClick={submitForm}>
                            Update
                        </Button>
                        <Button disabled={isSubmitting} color="primary" onClick={props.onClose}>
                            cancel
                        </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
 
export default EducationModal;